import React from 'react';

import styled, { keyframes } from 'styled-components';

const HIGHLIGHT_SIZE = 0.75;

const Container = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
`;

const itemShine = keyframes`
    to {
        left: 200%;
    }
`;

const AnimatedShimmer = styled.div`
    position: absolute;
    width: ${HIGHLIGHT_SIZE * 100}%;
    height: 100vh;
    left: ${-(HIGHLIGHT_SIZE * 2) * 100}%;
    animation: ${itemShine} 1s linear infinite;
    background-image: linear-gradient(
        100deg,
        rgba(255, 255, 255, 0),
        ${(props) => props.theme.colors.background} 50%,
        rgba(255, 255, 255, 0) 100%
    );
`;

const Shimmer: React.FC = () => (
    <Container>
        <AnimatedShimmer />
    </Container>
);

export default Shimmer;
